import { obj_type, array_type, class_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { Message, dispatchCtx, documentsCtx } from "../../Documents/DocumentContext.js";
import { some, value as value_94, unwrap, map, defaultArg } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { moveDocHere, filterDocs, actionColumn, hiddenColumn, syncColumn, sourceColumn, dateColumn, Table_FilenameCell_Z6EA07FE8, DocumentDragForm, DragTarget, docTableIconHeader, docTableTextHeader, TreeState } from "../../Documents/DocumentHelpers.js";
import { API_Document_Download, generateQueryString, API_Document_CustomerDocuments } from "../../Shared/Urls.js";
import { toString } from "../../fable_modules/fable-library-js.4.24.0/Types.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Document$, Document$_$reflection } from "../../Shared/ApiDataTypes.js";
import { testRedirect, extraCoders } from "../../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { toString as toString_1 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, uncurry2 } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableContainer, Collapse, Typography, ListItemIcon, ListItemButton, TableBody, Link, IconButton, TableHead, TableRow, Table } from "@mui/material";
import { toArray, empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { map as map_1 } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { Documents_DocumentSource_FromId_Z524259A4 } from "../../Shared/Shared.js";
import { parse } from "../../fable_modules/fable-library-js.4.24.0/Guid.js";
import Clear from "@mui/icons-material/Clear";
import { toDateStr } from "../../Locale.js";
import { parse as parse_1 } from "../../fable_modules/fable-library-js.4.24.0/Date.js";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import Download from "@mui/icons-material/Download";
import { UploadModule_UploadForm, UploadTarget, Upload_EditButton_13687765 } from "./Upload.js";
import Delete from "@mui/icons-material/Delete";
import { loadingIndicatorSmall, SnackError, wrapTooltip } from "../../ViewHelpers.js";
import { DocumentHiddenForm } from "./DocumentHide.js";
import { Form } from "./Delete.js";
import { getFiles } from "../../Utils.js";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Publish from "@mui/icons-material/Publish";

export class TopLevel {
    constructor() {
    }
}

export function TopLevel_$reflection() {
    return class_type("Components.Documents.TopLevel", undefined, TopLevel);
}

export function TopLevel_Table_763CA090(topLevel_Table_763CA090InputProps) {
    let elements_5, children_1, children, children_7;
    const documents = topLevel_Table_763CA090InputProps.documents;
    const machineId = topLevel_Table_763CA090InputProps.machineId;
    const customerId = topLevel_Table_763CA090InputProps.customerId;
    const groupId = topLevel_Table_763CA090InputProps.groupId;
    const ctx = reactApi.useContext(ctx_1);
    const model = reactApi.useContext(documentsCtx);
    const dispatch = reactApi.useContext(dispatchCtx);
    const documents_1 = (machineId != null) ? defaultArg(documents, model.CustomerDocs) : model.CustomerDocs;
    const addDocs = (documents_2) => {
        dispatch((machineId != null) ? (new Message(1, [machineId, undefined, documents_2])) : (new Message(2, [documents_2])));
    };
    const removeDoc = (documentId) => {
        dispatch((machineId != null) ? (new Message(6, [machineId, documentId])) : (new Message(8, [documentId])));
    };
    const updateDoc = (document$) => {
        dispatch((machineId != null) ? (new Message(17, [machineId, undefined, document$])) : (new Message(19, [document$])));
    };
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const loading = patternInput[0];
    const mainElemRef = reactApi.useRef(undefined);
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    let patternInput_2;
    const initial_2 = new TreeState((machineId != null) && (documents_1.length > 0), undefined, undefined, undefined, false);
    patternInput_2 = reactApi.useState(initial_2);
    const topState = patternInput_2[0];
    const setState = patternInput_2[1];
    let isAdmin;
    const matchValue = ctx.Session;
    if (matchValue != null) {
        const s = matchValue;
        isAdmin = (s.IsAdmin ? true : s.IsSuperAdmin);
    }
    else {
        isAdmin = false;
    }
    let isPtg;
    const matchValue_1 = ctx.Session;
    isPtg = ((matchValue_1 != null) && matchValue_1.IsPtg);
    const dependencies = [customerId, machineId, model.Filter.ShowDeleted];
    reactApi.useEffect(() => {
        let properties_2;
        if (machineId == null) {
            const requestPath = API_Document_CustomerDocuments(customerId) + generateQueryString([["deleted", toString(model.Filter.ShowDeleted)]]);
            setLoading(true);
            let pr_2;
            let pr_1;
            const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Document$_$reflection()), undefined, undefined);
            const data_1 = undefined;
            const caseStrategy_2 = undefined;
            const extra_2 = extraCoders;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(requestPath, properties_3).then((_arg_2) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg_2, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Document$_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_3) => {
                        let matchValue_5;
                        return Promise.resolve((matchValue_5 = fromString(uncurry2(decoder_1_1), _arg_3), (matchValue_5.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_5.fields[0]])])) : (new FSharpResult$2(0, [matchValue_5.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
            pr_2.then((res_1) => {
                setLoading(false);
                if (res_1.tag === 1) {
                    setErrMsg("Kunne ikke laste dokumenter");
                }
                else {
                    const documents_4 = res_1.fields[0];
                    if (documents_4.length > 0) {
                        setState(new TreeState(true, topState.HideForm, topState.UploadForm, topState.DeleteForm, topState.DragHovering));
                    }
                    dispatch(new Message(10, [documents_4]));
                }
            });
        }
    }, dependencies);
    const dependencies_2 = [documents_1];
    reactApi.useEffect(() => {
        if (machineId != null) {
            setState(new TreeState(!(documents_1.length === 0), topState.HideForm, topState.UploadForm, topState.DeleteForm, topState.DragHovering));
        }
        else {
            console.debug("Customer Top level docs changed", documents_1);
        }
    }, dependencies_2);
    const table = MuiHelpers_createElement(Table, [["size", "small"], (elements_5 = [(children_1 = singleton_1((children = toList(delay(() => append(singleton(docTableTextHeader(ctx.Locale.t("Document.Document"))), delay(() => append(singleton(docTableTextHeader(ctx.Locale.t("History.Date"))), delay(() => append(singleton(docTableTextHeader(ctx.Locale.t("Document.Source"))), delay(() => append(singleton(docTableTextHeader(ctx.Locale.t("Document.Sync"))), delay(() => append(isAdmin ? singleton(docTableIconHeader(ctx.Locale.t("Visibility"))) : empty_1(), delay(() => append(singleton(docTableIconHeader(ctx.Locale.t("Document.Download"))), delay(() => (isAdmin ? append(singleton(docTableIconHeader(ctx.Locale.t("Edit"))), delay(() => singleton(docTableIconHeader(ctx.Locale.t("Delete"))))) : empty_1()))))))))))))))), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_7 = singleton_1(map_1((document$_3) => {
        const source = Documents_DocumentSource_FromId_Z524259A4(document$_3.SourceId);
        const downloadUrl = API_Document_Download(parse(document$_3.Guid));
        return MuiHelpers_createElement(TableRow, toList(delay(() => append(singleton(["key", document$_3.Guid]), delay(() => append((model.Editing && isAdmin) ? append(singleton(["draggable", true]), delay(() => append(singleton(["onDragStart", (e) => {
            const document$_2 = document$_3;
            console.debug("Started dragging doc!", document$_2);
            dispatch(new Message(11, [new DocumentDragForm(new DragTarget(document$_2, machineId == null), () => {
                if (machineId != null) {
                    throw new Error("todo: onDragStart");
                }
                else {
                    console.debug("Someone called the toplevel onmoved closure");
                    removeDoc(document$_2.Guid);
                }
            })]));
        }]), delay(() => singleton(["onDragEnd", (_arg) => {
            dispatch(new Message(11, [undefined]));
        }]))))) : empty_1(), delay(() => append(singleton(["style", createObj(toList(delay(() => (document$_3.IsDeleted ? singleton(["backgroundColor", "#c1c1c1"]) : empty_1()))))]), delay(() => {
            let elems_4;
            return singleton((elems_4 = toList(delay(() => append(singleton(createElement(Table_FilenameCell_Z6EA07FE8, {
                groupId: groupId,
                customerId: customerId,
                document: document$_3,
                machineId: unwrap(machineId),
                startAdornments: toArray(delay(() => {
                    let props_1;
                    return document$_3.IsDeleted ? singleton((props_1 = {
                        style: {
                            fontSize: 1.2 + "em",
                        },
                        color: "error",
                    }, react.createElement(Clear, props_1))) : empty_1();
                })),
            })), delay(() => append(singleton(dateColumn(toList(delay(() => ((document$_3.Date != null) ? singleton(createElement("span", {
                children: [toDateStr(ctx.DateFnsLocale, parse_1(value_94(document$_3.Date)))],
            })) : empty_1()))))), delay(() => append(singleton(sourceColumn([createElement("span", {
                children: [toString(source)],
            })])), delay(() => append(singleton(syncColumn(ctx.Locale, document$_3)), delay(() => append(isAdmin ? singleton(hiddenColumn(toList(delay(() => {
                let props_5, props_7;
                return document$_3.IsHidden ? singleton((props_5 = {
                    style: {
                        color: "#FF8C00",
                    },
                }, react.createElement(VisibilityOff, props_5))) : singleton((props_7 = {}, react.createElement(Visibility, props_7)));
            })))) : empty_1(), delay(() => {
                let elements_3, elements_2, props_9;
                return append(singleton(actionColumn([MuiHelpers_createElement(IconButton, [["color", "primary"], ["disabled", document$_3.ContentId == null], (elements_3 = [MuiHelpers_createElement(Link, [["href", downloadUrl], (elements_2 = [(props_9 = {}, react.createElement(Download, props_9))], ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elements_3))])])])), delay(() => {
                    let $key3025AD94;
                    return isAdmin ? append(singleton(actionColumn([($key3025AD94 = document$_3.Guid, createElement(Upload_EditButton_13687765, {
                        key: $key3025AD94,
                        $key: $key3025AD94,
                        customerId: document$_3.CustomerId,
                        onClose: (editedDocument) => {
                            console.debug("Document edited", editedDocument);
                            const matchValue_3 = editedDocument.Machine;
                            if (matchValue_3 != null) {
                                const newMachine = matchValue_3;
                                const matchValue_4 = editedDocument.CategoryTreeId;
                                if (matchValue_4 != null) {
                                    dispatch(new Message(4, [newMachine.Id, matchValue_4, editedDocument]));
                                }
                                else {
                                    updateDoc(editedDocument);
                                }
                            }
                            else {
                                dispatch(new Message(19, [editedDocument]));
                            }
                        },
                        document: document$_3,
                    }))])), delay(() => {
                        let child_2, props_13;
                        return singleton(actionColumn([(child_2 = MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_13 = {}, react.createElement(Delete, props_13))], ["onClick", (_arg_4) => {
                            setState(new TreeState(topState.IsOpen, topState.HideForm, topState.UploadForm, document$_3, topState.DragHovering));
                        }]]), wrapTooltip(ctx.Locale.t("Document.Delete"), child_2))]));
                    })) : empty_1();
                }));
            })))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_4))]));
        })))))))));
    }, filterDocs(ctx.DateFnsLocale, undefined, model.Filter, documents_1))), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_7))]]))], ["children", reactApi.Children.toArray(Array.from(elements_5))])]);
    const xs_2 = toList(delay(() => append(singleton(createElement(SnackError, {
        errMsg: unwrap(patternInput_1[0]),
        dismiss: () => {
            setErrMsg(undefined);
        },
    })), delay(() => {
        let matchValue_6, hf;
        return append((matchValue_6 = topState.HideForm, (matchValue_6 != null) ? ((hf = matchValue_6, singleton(createElement(DocumentHiddenForm, {
            docId: hf.Guid,
            name: hf.Title,
            isHidden: hf.IsHidden,
            onClose: (didToggle) => {
                if (didToggle) {
                    updateDoc(new Document$(hf.Guid, hf.Number, hf.CustomerId, hf.Title, hf.CategoryTreeId, hf.TypeId, hf.Machine, hf.SourceId, hf.Date, hf.Uploader, !hf.IsHidden, hf.IsDeleted, hf.Version, hf.Uploaded, hf.ManuallyMoved, hf.ContentId, hf.Filename, hf.ContentSizeBytes, hf.Versions));
                }
                setState(new TreeState(topState.IsOpen, undefined, topState.UploadForm, topState.DeleteForm, topState.DragHovering));
            },
        })))) : (empty_1())), delay(() => {
            let matchValue_7, uf, target;
            return append((matchValue_7 = topState.UploadForm, (matchValue_7 != null) ? ((uf = matchValue_7, (target = ((machineId != null) ? (new UploadTarget(0, [value_94(machineId)])) : (new UploadTarget(1, [customerId]))), singleton(createElement(UploadModule_UploadForm, {
                target: target,
                customerId: customerId,
                customerAttachment: false,
                files: uf,
                onClose: (newDocs) => {
                    addDocs(newDocs);
                    setState(new TreeState(topState.IsOpen, topState.HideForm, undefined, topState.DeleteForm, topState.DragHovering));
                },
            }))))) : (empty_1())), delay(() => {
                let matchValue_8, document$_4;
                return append((matchValue_8 = topState.DeleteForm, (matchValue_8 != null) ? singleton((document$_4 = matchValue_8, createElement(Form, {
                    onClose: (deletedDocOpt) => {
                        if (deletedDocOpt != null) {
                            const doc = deletedDocOpt;
                            if (doc.IsDeleted) {
                                removeDoc(doc.Guid);
                            }
                            else {
                                updateDoc(new Document$(doc.Guid, doc.Number, doc.CustomerId, doc.Title, doc.CategoryTreeId, doc.TypeId, doc.Machine, doc.SourceId, doc.Date, doc.Uploader, doc.IsHidden, true, doc.Version, doc.Uploaded, doc.ManuallyMoved, doc.ContentId, doc.Filename, doc.ContentSizeBytes, doc.Versions));
                            }
                        }
                        setState(new TreeState(topState.IsOpen, topState.HideForm, topState.UploadForm, undefined, topState.DragHovering));
                    },
                    document: document$_4,
                }))) : (empty_1())), delay(() => singleton(createElement("div", createObj(toList(delay(() => append(singleton(["id", "top-level-documents-holder"]), delay(() => append(singleton(["ref", mainElemRef]), delay(() => append(singleton(["style", createObj(toList(delay(() => append(singleton(["borderRadius", 10 + "px"]), delay(() => append(singleton(["width", 100 + "%"]), delay(() => (topState.DragHovering ? singleton(["backgroundColor", "#B0E0E6"]) : empty_1()))))))))]), delay(() => append((model.Editing && isAdmin) ? append(singleton(["onDragOver", (ev) => {
                    ev.preventDefault();
                }]), delay(() => append(singleton(["onDragEnter", (ev_1) => {
                    ev_1.preventDefault();
                    console.debug("Some document is dragged over me!", machineId);
                    setState(new TreeState(true, topState.HideForm, topState.UploadForm, topState.DeleteForm, true));
                }]), delay(() => append(singleton(["onDragLeave", (ev_2) => {
                    ev_2.preventDefault();
                    if (mainElemRef.current != null) {
                        const elem = value_94(mainElemRef.current);
                        const relatedNode = ev_2.relatedTarget;
                        if (relatedNode.contains(elem)) {
                            setState(new TreeState(topState.IsOpen, topState.HideForm, topState.UploadForm, topState.DeleteForm, false));
                        }
                    }
                }]), delay(() => singleton(["onDrop", (ev_3) => {
                    ev_3.preventDefault();
                    console.debug("Someone dropped a document on me!", model.DragTarget);
                    const matchValue_2 = model.DragTarget;
                    if (matchValue_2 != null) {
                        const dt = matchValue_2;
                        const document$_1 = dt.DragTarget.Document;
                        moveDocHere(dt, undefined, machineId, (res) => {
                            if (res.tag === 0) {
                                const newDocument = new Document$(document$_1.Guid, document$_1.Number, document$_1.CustomerId, document$_1.Title, undefined, document$_1.TypeId, document$_1.Machine, document$_1.SourceId, document$_1.Date, document$_1.Uploader, false, document$_1.IsDeleted, document$_1.Version, document$_1.Uploaded, defaultArg(res.fields[0].ManuallyMoved, false), document$_1.ContentId, document$_1.Filename, document$_1.ContentSizeBytes, document$_1.Versions);
                                if (document$_1.IsHidden && !newDocument.IsHidden) {
                                    dispatch(new Message(3, [newDocument]));
                                }
                                if (dt.DragTarget.FromTopLevel) {
                                    console.debug("Top-level documents received document from docs without machines");
                                    dt.OnMoved();
                                    addDocs([newDocument]);
                                }
                                else if (machineId != null) {
                                    dispatch(new Message(4, [value_94(machineId), undefined, newDocument]));
                                }
                                else {
                                    dispatch(new Message(6, [defaultArg(map((m) => m.Id, newDocument.Machine), -1), newDocument.Guid]));
                                    addDocs([new Document$(newDocument.Guid, newDocument.Number, newDocument.CustomerId, newDocument.Title, newDocument.CategoryTreeId, newDocument.TypeId, undefined, newDocument.SourceId, newDocument.Date, newDocument.Uploader, newDocument.IsHidden, newDocument.IsDeleted, newDocument.Version, newDocument.Uploaded, newDocument.ManuallyMoved, newDocument.ContentId, newDocument.Filename, newDocument.ContentSizeBytes, newDocument.Versions)]);
                                }
                            }
                        });
                        setState(new TreeState(topState.IsOpen, topState.HideForm, topState.UploadForm, topState.DeleteForm, false));
                    }
                    else {
                        const files = getFiles(ev_3.dataTransfer.files);
                        if (files.length === 0) {
                            console.warn(some("onDrop without DragTarget or files"));
                        }
                        else {
                            setState(new TreeState(topState.IsOpen, topState.HideForm, files, topState.DeleteForm, false));
                        }
                    }
                    dispatch(new Message(11, [undefined]));
                }]))))))) : empty_1(), delay(() => {
                    let elems_13, elements_8, children_10, elems_9, elements_10;
                    return singleton((elems_13 = [MuiHelpers_createElement(ListItemButton, [["onClick", (_arg_6) => {
                        setState(new TreeState(!topState.IsOpen, topState.HideForm, topState.UploadForm, topState.DeleteForm, topState.DragHovering));
                    }], ["divider", false], (elements_8 = [(children_10 = toList(delay(() => {
                        let props_18, props_20;
                        return loading ? singleton(loadingIndicatorSmall()) : (topState.IsOpen ? singleton((props_18 = {}, react.createElement(ExpandMore, props_18))) : singleton((props_20 = {}, react.createElement(ChevronRight, props_20))));
                    })), MuiHelpers_createElement(ListItemIcon, [["children", reactApi.Children.toArray(Array.from(children_10))]])), createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 10 + "px",
                    }], (elems_9 = toList(delay(() => append(singleton(MuiHelpers_createElement(Typography, [["style", {
                        flexGrow: 1,
                    }], ["children", ctx.Locale.t("Document.DocumentFolder")]])), delay(() => {
                        let elements_7, props_23;
                        return (isAdmin ? true : isPtg) ? singleton(MuiHelpers_createElement(IconButton, [["onClick", (ev_4) => {
                            ev_4.stopPropagation();
                            setState(new TreeState(topState.IsOpen, topState.HideForm, [], topState.DeleteForm, topState.DragHovering));
                        }], ["size", "small"], (elements_7 = [(props_23 = {
                            fontSize: "small",
                        }, react.createElement(Publish, props_23))], ["children", reactApi.Children.toArray(Array.from(elements_7))])])) : empty_1();
                    })))), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elements_8))])]), MuiHelpers_createElement(Collapse, [["in", !loading && topState.IsOpen], (elements_10 = [MuiHelpers_createElement(TableContainer, [["style", {
                        minHeight: 10,
                        paddingLeft: 20 + "px",
                        paddingRight: 20 + "px",
                        paddingBottom: 20 + "px",
                    }], ["children", reactApi.Children.toArray([table])]])], ["children", reactApi.Children.toArray(Array.from(elements_10))])])], ["children", reactApi.Children.toArray(Array.from(elems_13))]));
                })))))))))))))));
            }));
        }));
    }))));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

